module.exports = __webpack_public_path__ + "static/media/picture.84d76889.svg";